import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
import { Modal } from 'foundations-components/transitional/components/Modal';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledModal = styled(_ref => {
  let {
      use = 'conversational'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Modal, Object.assign({
    use: use
  }, props));
}).withConfig({
  displayName: "StyledModal",
  componentId: "sc-19arj9d-0"
})(["&&&{background-color:", ";}"], props => props.hideBackground ? 'transparent' : undefined);